<template>
    <tr class='border-t border-indigo-300'>
        <td class="px-2 py-2 whitespace-nowrap text-gray-700 dark:text-gray-300">
            <p class="flex items-center">
                {{ formatDatetime(quittance.created_at) }}
            </p>
        </td>
        <td class="px-2 py-2 whitespace-nowrap text-gray-700 dark:text-gray-300">
            <p>
                {{ quittance.title }}
            </p>
        </td>
        <td class="px-2 py-2 text-sm flex justify-end whitespace-nowrap">
            <button class="btn-primary ml-1" @click.prevent="confirmSendQuittance()">
                <font-awesome-icon class="text-sm text-white" :icon="['fa', 'paper-plane']" />
            </button>
            <button class="btn-info ml-1" @click.prevent="openQuittanceInNewTab()">
                <font-awesome-icon class="text-sm text-white" :icon="['fa', 'external-link-alt']" />
            </button>
            <button class="btn-success ml-1" @click.prevent="downloadQuittance()">
                <font-awesome-icon class="text-sm text-white" :icon="['fa', 'download']" />
            </button>
        </td>
    </tr>
</template>

<script>

export default {
    data() {
        return {
        }
    },

    props: {
        quittance: {
            type: Object,
            default() {
                return {}
            }
        },
        loyerUuid: {
            type: String,
        }
    },

    emits: ['refresh'],

    methods: {
        confirmSendQuittance() {
            this.$confirm({
                variant: 'info',
                title: 'Envoyer la quittance',
                message: "Vous êtes sur le point d'envoyer la quittance au(x) locataire(s) par email, voulez-vous continuer ?",
                confirmText: 'Envoyer',
                action: () => this.sendQuittance(),
            });
        },

        async sendQuittance() {
            if (!this.$route.params.bienUuid || !this.loyerUuid || !this.quittance.uuid) {
                return;
            }

            await this.$api.bien.sendQuittance(this.$route.params.bienUuid, this.loyerUuid, this.quittance.uuid)
            .then(async () => {
                this.$toast({title: 'Succès', description: "La quittance à bien été envoyé."}, this.$toastSuccess);
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })
        },

        async downloadQuittance() {
            if (!this.$route.params.bienUuid || !this.loyerUuid || !this.quittance.uuid) {
                return;
            }

            const {data, filename} = await this.$api.bien.downloadQuittance(this.$route.params.bienUuid, this.loyerUuid, this.quittance.uuid)
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            const blob = new Blob([data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
        
            link.setAttribute('download', filename);

            document.body.appendChild(link);
            link.click();

            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        },

        async openQuittanceInNewTab() {
            if (!this.$route.params.bienUuid || !this.loyerUuid || !this.quittance.uuid) {
                return;
            }

            const {data} = await this.$api.bien.downloadQuittance(this.$route.params.bienUuid, this.loyerUuid, this.quittance.uuid)
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            const blob = new Blob([data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            window.open(url, '_blank');
        }
    }
};
</script>
